import { CSRF_TOKEN } from "@pages/csrf";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";

import { QueryClient } from "@tanstack/react-query";
import type { paths as AdminApiPaths } from "./api_utils/schema-admin-api";
import type { paths as StaffPaths } from "./api_utils/schema-staff";
import type { paths as LendingApiPaths } from "./api_utils/schema-lending";
import type { paths as PlmApiPaths } from "./api_utils/schema-plm-api";

const staffFetchClient = createFetchClient<StaffPaths>({
  headers: {
    "Content-Type": "application/json",
    "X-CSRFToken": CSRF_TOKEN,
  },
  querySerializer: {
    array: {
      style: "form",
      explode: false,
    },
  },
});
export const adminApiFetchClient = createFetchClient<AdminApiPaths>({
  headers: {
    "Content-Type": "application/json",
    "X-CSRFToken": CSRF_TOKEN,
  },
  querySerializer: {
    array: {
      style: "form",
      explode: false,
    },
  },
});
export const lendingApiFetchClient = createFetchClient<LendingApiPaths>({
  headers: {
    "Content-Type": "application/json",
    "X-CSRFToken": CSRF_TOKEN,
  },
  querySerializer: {
    array: {
      style: "form",
      explode: false,
    },
  },
});
export const plmApiFetchClient = createFetchClient<PlmApiPaths>({
  headers: {
    "Content-Type": "application/json",
    "X-CSRFToken": CSRF_TOKEN,
  },
  querySerializer: {
    array: {
      style: "form",
      explode: false,
    },
  },
});

export const $staffApi = createClient(staffFetchClient);
export const $adminApi = createClient(adminApiFetchClient);
export const $lendingApi = createClient(lendingApiFetchClient);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1 * 60 * 1000, // 1 minute
    },
  },
});
